import 'bootstrap/dist/css/bootstrap.min.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';
import 'animate.css/animate.compat.css';
import '../css/msg-container.css';
import '../css/login.css';
import '../../../icomoon-v1.0/style.css';
//import '../js/login.js';


$(function(){
    $('body').css('visibility', 'visible');
});

// Inícia popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})

if ($('input[name=username]').length > 0 && $('input[name=password]').length && $('input[name=email]').length > 0) {
    const doubble_form_login = {
        username: $('input[name=username]'),
        password: $('input[name=password]'),
        email: $('input[name=email]'),
        username_popover: new bootstrap.Popover(username),
        password_popover: new bootstrap.Popover(password),
        email_popover: new bootstrap.Popover(email),
        self,
        init: function() {
            self = this;
            self.username.add(self.password).add(self.email).on('focus', function() {
                $(this).prev().removeClass('label-normal').addClass('label-focus');
            });
            self.username.add(self.password).add(self.email).on('blur', function() {
                if ($(this).val().length == 0)
                    $(this).prev().removeClass('label-focus').addClass('label-normal');
            });
            self.username.on('keyup paste', function() {
                self.chk_login_text();
            });
            self.password.on('keyup', function() {
                self.chk_login_text();
            });
            self.password.on('paste', function() {
                setTimeout(self.chk_login_text(), 600)
            });
            self.email.on('keyup', function() {
                self.chk_recover_text();
            });
            self.email.on('paste', function() {
                setTimeout(self.chk_recover_text(), 600)
            });

            // Desloca para o panel do Login
            $('#go-to-log').on('click', function(e) {
                e.preventDefault();
                self.email_popover.hide();
                $('#panel-rec-login').removeClass("slideInRight").addClass("animated slideOutRight");
                $('#panel-login').removeClass("slideOutLeft").addClass("animated slideInLeft");

            });

            // Desloca para o panel da recuperação dos dados de acesso
            $('#go-to-logrec').on('click', function(e) {
                e.preventDefault();
                self.username_popover.hide();
                self.password_popover.hide();
                $('#panel-login').removeClass('slideInLeft').addClass("animated slideOutLeft").delay('4000');
                $('#panel-rec-login').removeClass('slideOutRight').show().addClass("animated slideInRight");
            });
            // Para o botão do login fazer surgir ou não a popover de aviso
            $('button[name="entrar_bt"]').on('click', function(e) {
                if (!self.check_login_user()) {
                    //$('[name="username"]').popover('show');
                    self.username_popover.show();
                    self.username.trigger('focus');
                } else if (!self.check_login_pass()) {
                    //$('[name="username"]').popover('hide');
                    self.username_popover.hide();
                    //$('[name="password"]').popover('show');
                    self.password_popover.show();
                    self.password.trigger('focus');
                }
            });

            $('button[name="recuperar_bt"]').on('click', function(e) {
                if (!self.chk_recover_text()) {
                    self.email_popover.show();
                    self.email.trigger('focus');
                } else {
                    self.email_popover.hide();
                }
            });
        },
        isValidEmail: function(emailText) {
            var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
            return pattern.test(emailText);
        },
        check_login_user: function() {
            if (self.username.val() != '') return true;
        },
        check_login_pass: function() {
            if (self.password.val() != '') return true;
            return false;
        },
        check_login_inputs: function() {
            if (self.check_login_user() && self.check_login_pass()) return true;
            return false;
        },
        check_recover_email: function() {
            if (self.email.val() != '' && self.isValidEmail(self.email.val())) return true;
            return false;
        },
        check_recover_inputs: function() {
            if (self.check_recover_email()) return true;
            return false;
        },
        chk_login_text: function() {
            self.username_popover.hide();
            self.password_popover.hide();
            if (self.check_login_inputs()) {
                $('button[name="entrar_bt"]').css('opacity', 1);
                $('button[name="entrar_bt"]').attr('type', 'submit');
                return true;
            } else {
                $('button[name="entrar_bt"]').css('opacity', 1);
                $('button[name="entrar_bt"]').attr('type', 'button');
                return false;
            }
        },
        chk_recover_text: function() {
            if (self.check_recover_inputs()) {
                $('button[name="recuperar_bt"]').css('opacity', 1);
                $('button[name="recuperar_bt"]').attr('type', 'submit');
                self.email_popover.hide();
                return true;
            } else {
                $('button[name="recuperar_bt"]').css('opacity', 1);
                $('button[name="recuperar_bt"]').attr('type', 'button');
                self.email_popover.show();
                return false;
            }
        },
    }


    doubble_form_login.init();
}

// Para o toggle do campo da password: visível / não visível
$('[data-target=password-toggle]').on('click', function(e) {
    if ($('.password-toggle').attr('type') == 'password') {
        $('.password-toggle').attr('type', 'text');
        $(this).removeClass('icon-eye-blocked');
        $(this).addClass('icon-eye');
    } else {
        $('.password-toggle').attr('type', 'password');
        $(this).removeClass('icon-eye');
        $(this).addClass('icon-eye-blocked');
    }
})


$('.msg-container, .msg-container-fluid').find('.btn').on('click', function() {
    $(this).parent().remove();
})


if ($('.msg-container-new').is(':visible')) {
    $('.msg-container-new').on('click', function(event) {
        if (!$(event.target).closest('.msg-content').length)
            $(this).remove();
    })
}
$('.msg-container-new').find('.msg-content').find('button').on('click', function() {
    $('.msg-container-new').remove();
})

//export default doubble_form_login;